module.exports = __webpack_public_path__ + "static/rocket-on-back.414dca2b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/rocket-on-back.svg
// module id = 137
// module chunks = 35783957827783 226020273838829